import React from 'react';
import Markdown from 'react-markdown';
import styled from 'styled-components';
import remarkGfm from 'remark-gfm';

const MarkdownDiv = styled.div`
  padding: 16px 40px;
  border: 1px solid var(--color-border-secondary);
  border-radius: 16px;
  background-color: var(--color-bg-primary);
  color: var(--color-text-primary);

  p,
  li,
  td,
  th,
  blockquote {
    color: var(--color-text-primary);
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: var(--color-text-primary);
  }

  h1,
  h2 {
    border-bottom: 1px solid var(--color-border-secondary);
    padding-bottom: 8px;
  }

  a {
    color: var(--color-text-link);
    &:hover {
      color: var(--color-text-link-hover);
    }
  }

  code {
    background-color: var(--color-bg-tertiary);
    color: var(--color-text-secondary);
    border-radius: 4px;
    padding: 2px 6px;
  }

  pre {
    background-color: var(--color-bg-tertiary);
    border-radius: 8px;
    padding: 12px 16px;
    overflow-x: auto;

    code {
      background-color: transparent;
      padding: 0;
    }
  }

  blockquote {
    border-left: 4px solid var(--color-border-secondary);
    margin-left: 0;
    padding-left: 16px;
    color: var(--color-text-secondary);
  }

  ul {
    line-height: 1.75;
    padding-left: 32px;
  }

  hr {
    border-color: var(--color-border-secondary);
  }

  tr {
    &:nth-of-type(2n) {
      background-color: var(--color-bg-secondary);
    }
  }

  td,
  th {
    border: 1px solid var(--color-border-secondary);
    padding: 12px 16px;
  }

  tbody {
    tr {
      &:hover {
        background-color: var(--color-bg-tertiary);
      }
    }
  }

  th {
    text-align: left;
    background-color: var(--color-bg-secondary);
  }
`;

const FleetOpsMarkdown = ({ markdown }: { markdown: string }) => {
  return (
    <MarkdownDiv>
      <Markdown remarkPlugins={[remarkGfm]}>{markdown}</Markdown>
    </MarkdownDiv>
  );
};

export default FleetOpsMarkdown;
